import { render, staticRenderFns } from "./ProjectControl.vue?vue&type=template&id=3371e6e5&"
import script from "./ProjectControl.vue?vue&type=script&lang=js&"
export * from "./ProjectControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3371e6e5')) {
      api.createRecord('3371e6e5', component.options)
    } else {
      api.reload('3371e6e5', component.options)
    }
    module.hot.accept("./ProjectControl.vue?vue&type=template&id=3371e6e5&", function () {
      api.rerender('3371e6e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/ProjectControl.vue"
export default component.exports